import { createTheme, responsiveFontSizes } from '@mui/material/styles';

/**
 * Brand design tokens — the single source of truth for the Werklibuebe look.
 * These are the values that used to be hardcoded across every page (the orange
 * accent, the dark photo backgrounds, the overlay). Import `brand` instead of
 * repeating literals; the redesign refines spacing/typography, not the brand.
 */
export const brand = {
  orange: '#ff7300',
  orangeHover: '#e9a165',
  overlay: 'rgba(0, 0, 0, 0.4)',
  textOnDark: '#ffffff',
  // Public paths of the source images. Background helpers resolve these to the
  // generated WebP variants (see src/utils/images.ts).
  backgrounds: {
    hero: '/img/background_with_logo.png',
    page: '/img/background_without_logo.jpg',
    header: '/img/toptaskpicture.png',
  },
  logo: {
    // Transparent "WB · ESTD 2020" mark used in the header.
    mark: '/img/logo/transparent_logo_with_estb.png',
    // Plain transparent "WB" — legible at favicon sizes.
    icon: '/img/logo/BackgroundEraser_20260604_111444888.png',
  },
} as const;

let theme = createTheme({
  palette: {
    primary: { main: brand.orange, contrastText: brand.textOnDark },
  },
  typography: {
    // A slightly tightened display scale; responsiveFontSizes() below makes
    // every level fluid down to mobile so headings never overflow.
    h3: { fontWeight: 700, lineHeight: 1.15 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        containedPrimary: {
          '&:hover': { backgroundColor: brand.orangeHover },
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
